import { 
    GetTeams as DLGetTeams, 
    GetPlayersByTeam as DLGetPlayersByTeam 
} from './../DL/SportPlayer';

const GetTeams = async () => {
    try {
        const response = await DLGetTeams();
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al consultar el catálogo de equipos.' };
    }
};

const GetPlayersByTeam = async (teamId) => {
    try {
        const parsedId = parseInt(teamId, 10);
        if (isNaN(parsedId) || parsedId <= 0) {
            return { success: false, message: 'ID de equipo inválido.' };
        }

        const response = await DLGetPlayersByTeam(parsedId);
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al consultar los jugadores.' };
    }
};

export { GetTeams, GetPlayersByTeam };